import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex items-center space-x-2" }
const _hoisted_2 = ["aria-expanded"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Box = _resolveComponent("Box")!

  return (_openBlock(), _createBlock(_component_Box, {
    as: "section",
    color: _ctx.color,
    variant: _ctx.variant,
    class: "border-current rounded-md shadow"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Box, {
        as: "header",
        color: _ctx.color,
        variant: _ctx.variant,
        class: _normalizeClass(["w-full border-current border rounded-t-md", {
        'border-b-0': _ctx.open,
        'rounded-b-md': !_ctx.open,
      }])
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["p-2 w-full flex items-center justify-between rounded-t-md focus:outline-none focus:ring-4", {
          'rounded-b-md': !_ctx.open,
        }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle()))
          }, [
            _renderSlot(_ctx.$slots, "header", {}, () => [
              _createElementVNode("h2", _hoisted_1, [
                (_ctx.icon)
                  ? (_openBlock(), _createBlock(_component_Icon, {
                      key: 0,
                      type: "outline",
                      name: _ctx.icon,
                      class: "w-6 h-6"
                    }, null, 8, ["name"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.name), 1)
              ])
            ]),
            _createVNode(_component_Icon, {
              type: "solid",
              name: "chevron-down",
              class: _normalizeClass(["w-5 h-5 transition ease-in-out duration-100", { transform: _ctx.open, 'rotate-180': _ctx.open }])
            }, null, 8, ["class"])
          ], 2)
        ]),
        _: 3
      }, 8, ["color", "variant", "class"]),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "transform scale-y-95",
        "enter-to-class": "transform scale-y-100",
        "leave-active-class": "transition ease-in duration-100",
        "leave-from-class": "transform scale-y-100",
        "leave-to-class": "transform scale-y-95"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("main", {
            "aria-expanded": _ctx.open,
            class: "border border-current rounded-b-md"
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 8, _hoisted_2), [
            [_vShow, _ctx.open]
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["color", "variant"]))
}